/**
 * GlobalFooter functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class GlobalFooter {
/**
   * Constructs a new GlobalFooter instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.accordionWrappers = this.element.querySelectorAll('.accordion-wrapper')

    this.accordionWrappers.forEach(accordion => {
      const toggle = accordion.querySelector('header')
      toggle.addEventListener('click', () => {
        if (accordion.classList.contains('active')) {
          this.close(this.accordionWrappers)
        } else {
          this.close(this.accordionWrappers)
          this.open(accordion)
        }
      })
    })
  }
  open (accordion) {
    accordion.classList.add('active')
  }
  close (accordionWrappers) {
    this.accordionWrappers.forEach(element => {
      element.classList.remove('active')
    })
  }
}
